import type { Dispatch, FunctionComponent, SetStateAction } from "react";

import { PostiesQuizCheckbox } from "scmp-app/components/posties/quiz/quiz-checkbox";
import { PostiesQuizRadioButton } from "scmp-app/components/posties/quiz/quiz-radio-button";
import type { Answers } from "scmp-app/components/posties/quiz/types";
import type { AnswerType } from "scmp-app/components/posties/student-form/types";

import { Container } from "./styles";

type Props = {
  answer: Answers;
  answerType: AnswerType;
  className?: string;
  correctAnswer: null | string[];
  isCorrect: boolean | null;
  selectedAnswer: null | string[];
  setSelectedAnswer: Dispatch<SetStateAction<null | string[]>>;
};
export const PostiesQuizAnswer: FunctionComponent<Props> = ({
  answer,
  answerType,
  className,
  correctAnswer,
  isCorrect,
  selectedAnswer,
  setSelectedAnswer,
}) => {
  const onValueChange = (value: string[]) => {
    setSelectedAnswer(value);
  };

  const renderAnswer = () => {
    switch (answerType) {
      case "multiple_choice":
        return (
          <PostiesQuizCheckbox
            answer={answer}
            correctAnswer={correctAnswer}
            isCorrect={isCorrect}
            onValueChange={value => onValueChange(value)}
            selectedAnswer={selectedAnswer}
          />
        );
      case "radio_button":
        return (
          <PostiesQuizRadioButton
            answer={answer}
            correctAnswer={correctAnswer}
            isCorrect={isCorrect}
            onValueChange={value => onValueChange([value])}
            selectedAnswer={selectedAnswer}
          />
        );
    }
  };

  return <Container className={className}>{renderAnswer()}</Container>;
};

PostiesQuizAnswer.displayName = "PostiesQuizAnswer";
